// extracted by mini-css-extract-plugin
export default {"backtop":"LicensesListing_backtop__NWxUj"};